import React from 'react'
import type { Icon } from 'shared/utils'

const Plus = (props: Icon) => {
    const { color = '#BB1E32', size = 24, className = 'plus' } = props
    return (
        <svg className={className} width={size} height={size}>
            <path
                fill={color}
                fillRule="evenodd"
                d="M13.006 10.995v-5.99a1.004 1.004 0 1 0-2.01 0v5.99h-5.99a1.004 1.004 0 1 0 0 2.01h5.99v5.99a1.004 1.004 0 1 0 2.01 0v-5.99h5.989a1.004 1.004 0 1 0 0-2.01h-5.99z"
            />
        </svg>
    )
}

export { Plus }
